export * from '@primeuix/themes/material/floatlabel';
export { default } from '@primeuix/themes/material/floatlabel';
